// extracted by mini-css-extract-plugin
module.exports = {"depositStablecoinsWrap":"DepositStablecoins_depositStablecoinsWrap__3S6aA","metricList":"DepositStablecoins_metricList__3Qg7x"};